/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2024
 */

import { Component } from 'llama'
import FaceDrawer from '../../common/FaceDrawer'
import FacePartSelector from './FacePartSelector'

export default class FacePartContour extends Component {
  constructor (opt) {
    super({
      ...opt,
      html: () => '<div id="part-choice-contour" class="part-choice square"></div>'
    })
  }

  init (params, path) {
    const { eventBus, context } = this

    const faceDrawer = new FaceDrawer()
    this.addChildren(
      params, path,

      new FacePartSelector({
        eventBus,
        context,
        box: 'part-choice-contour',
        num: 4,
        draw (ctx, i) {
          faceDrawer.drawNoHairFace(ctx, i, 0.9, 5)
        },
        shape: 'face',
        width: 90,
        height: 90
      })
    )
  }
}
